import { cn } from '@/lib/utils'
import { initialsOf } from '@/lib/profile'

interface AvatarProps {
	name: string
	size?: 'sm' | 'md' | 'lg'
	className?: string
}

const SIZE_CLASSES = {
	sm: 'size-7 text-[11px]',
	md: 'size-9 text-xs',
	lg: 'size-14 text-base',
}

export function Avatar({ name, size = 'md', className }: AvatarProps) {
	return (
		<span
			aria-hidden="true"
			className={cn(
				'inline-flex shrink-0 items-center justify-center rounded-full bg-muted font-medium tracking-wide text-foreground',
				SIZE_CLASSES[size],
				className,
			)}
		>
			{initialsOf(name)}
		</span>
	)
}
